import React from "react";
import { CounterContainer } from "../../../charts/lawsuit/LawsuitCounter/style";
import { CounterWithComparisonSkeleton } from "./styles";

const LawsuitCounterSkeleton = () => {
    return (
      <CounterContainer>
        <CounterWithComparisonSkeleton />
        <CounterWithComparisonSkeleton />
        <CounterWithComparisonSkeleton />
      </CounterContainer>
    );
};

export default LawsuitCounterSkeleton;
 